import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton, Modal, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useState } from "react";

const RedFlagSessionTab = ({data}) => {


  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 20,
  });
  const [open, setOpen] = useState(false);
  const [selectedReason, setSelectedReason] = useState('');

  // Convert string date (dd-mm-yyyy) to Date object
  function convertToDateObject(dateString) {
    console.warn(dateString);
    const [day, month, year] = dateString.split('-');
    return new Date(`${year}-${month}-${day}`);
  }


  const rows = data.map((item, index) => ({
    id: index,
    sno: index + 1,
    ...item,
      date: convertToDateObject(item.date),
  }));

  const columnSchema = [
    { field: 'sno', headerName: 'S.no', flex: 0.5, align: 'center', headerAlign: 'left' },
    { field: 'student_name', headerName: 'Student Name', flex: 1 },
    {
      field: 'date',
      headerName: 'Date',
      flex: 1,
      type: 'date',
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => {
        const date = params.value;
        return date
          ? date.toLocaleDateString('en-US', {
              month: 'short',
              day: '2-digit',
              year: 'numeric',
            })
          : '';
      },
    },
    { field: 'duration', headerName: 'Duration', flex: 1 },
    { field: 'call_quality_score', headerName: 'Call Quality Score', flex: 1, align: 'center', headerAlign: 'left' },
    { field: 'call_type', headerName: 'Session Type', flex: 1 },
    { field: 'red_flag_status', headerName: 'Red Flag Identified', flex: 1 },
    { field: 'status', headerName: 'Session Status', flex: 1 },
  ];

  const handleRowClick = (params) => {
    setSelectedReason(params.row.red_flag_reason);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  return (
    <>
      <div style={{ width: '100%',  marginBottom: '100px', }}>
        <DataGrid
          rows={rows}
          columns={columnSchema}
          paginationModel={paginationModel}
          onPaginationModelChange={(newModel) => setPaginationModel(newModel)}
          autoHeight
          pageSizeOptions={[20, 50, 100]}
          onRowClick={handleRowClick}
          localeText={{ noRowsLabel: 'No Red-Flag Session Analysis available' }}
          sx={{
            'fontFamily': 'Nunito Sans, sans-serif',
            'fontSize': '14px',
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#ebebeb',
              color: '#000',
              fontWeight: 'bold',
              fontSize: '14px',
              padding: '6px',
            },
            '& .MuiDataGrid-cell': {
              padding: '6px',
              fontSize: '14px',
            },
            '& .MuiDataGrid-row:hover': {
              cursor: 'pointer',
              backgroundColor: '#f5f5f5',
            },
          }}
        />
      </div>


<Modal open={open} onClose={handleClose}>
  <Box
    sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 500,
      height: 350,
      bgcolor: 'background.paper',
      boxShadow: 24,
      p: 3,
      borderRadius: 2,
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    {/* Close button in top right */}
    <IconButton
      aria-label="close"
      onClick={handleClose}
      sx={{
        position: 'absolute',
        right: 8,
        top: 8,
      }}
    >
      <CloseIcon />
    </IconButton>

    <Typography variant="h6" gutterBottom>
      Red Flag Reason
    </Typography>

    {/* Scrollable content */}
    <Box
      sx={{
        overflowY: 'auto',
        flexGrow: 1,
        mt: 1,
      }}
    >
      <Typography
        variant="body1"
        component="div"
        dangerouslySetInnerHTML={{ __html: selectedReason }}
      />
    </Box>
  </Box>
</Modal>

    </>
  );
};

export default RedFlagSessionTab;
